import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { DarkModeContextProvider } from "./context/darkModeContext";
import { AuthContextProvider } from "./context/AuthContext";
import AppThemeProvider from "./theme/AppThemeProvider";

// Order matters: tokens define the custom properties, base consumes them,
// index.css only carries the display-scaling rules.
import "./style/tokens.css";
import "./style/base.css";
import "./index.css";

ReactDOM.render(
  <React.StrictMode>
    <DarkModeContextProvider>
      <AppThemeProvider>
        <AuthContextProvider>
          <App />
        </AuthContextProvider>
      </AppThemeProvider>
    </DarkModeContextProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
